module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Buried-Knights-Templar-1.2cde2b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Buried-Knights-Templar-1.jpg
// module id = ofIX
// module chunks = 0